import React, { useState } from "react";

//UI Material
import { Avatar, Card, Divider, Grid, Stack } from "@mui/material";

//Material Icons
import { Edit, Cancel } from "@mui/icons-material";

//Helpers
import {
  typographyForCustomizedFontSize,
  typographyForMainTitles,
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";
import { selectProductImage } from "../../Helpers/productSelector";

//Local components
import ContainedButton from "../basics/ContainedButton";
import CancelOrderDrawer from "../drawers/CancelOrderDrawer";
import EditOrderDrawer from "../drawers/EditOrderDrawer";

export default function ProductSpecificationsCard({ order, getData }) {
  const product = order.products[0].aditionalData;
  //User data from localStorage
  const userData = JSON.parse(localStorage.getItem("userData"));
  //State for open/close cancel order drawer
  const [cancelOrderDrawer, setCancelOrderDrawer] = useState(false);
  //State for open/close edit order drawer
  const [editOrderDrawer, setEditOrderDrawer] = useState(false);

  // ==========>Component<==========
  return (
    <Card raised sx={{ height: "100%" }}>
      <EditOrderDrawer
        open={editOrderDrawer}
        setOpen={setEditOrderDrawer}
        data={order}
        orderNumber={new URLSearchParams(window.location.search).get("orderId")}
        getData={getData}
      />
      <CancelOrderDrawer
        open={cancelOrderDrawer}
        setOpen={setCancelOrderDrawer}
        orderNumber={new URLSearchParams(window.location.search).get("orderId")}
        getData={getData}
      />
      <Grid container sx={{ padding: "20px" }} spacing={1}>
        <Grid item xs={12}>
          {typographyForSubtitles("Especificaciones", "secondary")}
        </Grid>

        <Grid item xs={12}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            textAlign="left"
          >
            <Avatar
              src={selectProductImage(product.productName)}
              alt="product-img"
              sx={{ height: "100px", width: "100px" }}
            />
            {typographyForMainTitles(product.productName)}
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>

        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            {typographyForCustomizedFontSize("Cantidad", "11px", null, "bold")}
            {typographyForText(order.numberOfProducts, "bold")}
          </Stack>
        </Grid>
        {/*Conditional rendering for POWER KW */}
        {product.powerKw && (
          <Grid item xs={6}>
            <Stack
              alignItems="flex-start"
              justifyContent="flex-start"
              textAlign="left"
            >
              {typographyForCustomizedFontSize(
                "Potencia",
                "11px",
                null,
                "bold"
              )}
              {typographyForText(`${product.powerKw}kW`, "bold")}
            </Stack>
          </Grid>
        )}
        {/**Conditional rendering for CONNECTOR TYPE */}
        {product.connectorType && (
          <Grid item xs={6}>
            <Stack
              alignItems="flex-start"
              justifyContent="flex-start"
              textAlign="left"
            >
              {typographyForCustomizedFontSize(
                "Tipo de conector de salida",
                "11px",
                null,
                "bold"
              )}
              {typographyForText(product.connectorType, "bold")}
            </Stack>
          </Grid>
        )}
        {/**Conditional rendering for POWER CONFIG TYPE */}
        {product.powerConfigType && (
          <Grid item xs={6}>
            <Stack
              alignItems="flex-start"
              justifyContent="flex-start"
              textAlign="left"
            >
              {typographyForCustomizedFontSize(
                "Tipo de configuración",
                "11px",
                null,
                "bold"
              )}
              {typographyForText(product.powerConfigType, "bold")}
            </Stack>
          </Grid>
        )}
        {/**Conditional rendering for RFID CARDS QUANTITY */}
        {product.rfidCardsQuantity > 0 && (
          <Grid item xs={6}>
            <Stack
              alignItems="flex-start"
              justifyContent="flex-start"
              textAlign="left"
            >
              {typographyForCustomizedFontSize(
                "Cantidad de tarjetas RFID",
                "11px",
                null,
                "bold"
              )}
              {typographyForText(product.rfidCardsQuantity, "bold")}
            </Stack>
          </Grid>
        )}
        {/**Conditional rendering for TSJ CABLE LENGTH */}
        {product.tsjCableLengthInMeters && (
          <Grid item xs={6}>
            <Stack
              alignItems="flex-start"
              justifyContent="flex-start"
              textAlign="left"
            >
              {typographyForCustomizedFontSize(
                "Longitud del cable TSJ",
                "11px",
                null,
                "bold"
              )}
              {typographyForText(
                `${product.tsjCableLengthInMeters} metros`,
                "bold"
              )}
            </Stack>
          </Grid>
        )}
        {/**Conditional rendering for CONNECTOR CABLE LENGTH */}
        {product.connectorCableLengthInMeters && (
          <Grid item xs={6}>
            <Stack
              alignItems="flex-start"
              justifyContent="flex-start"
              textAlign="left"
            >
              {typographyForCustomizedFontSize(
                "Longitud del cable del vehículo",
                "11px",
                null,
                "bold"
              )}
              {typographyForText(
                `${product.connectorCableLengthInMeters} metros`,
                "bold"
              )}
            </Stack>
          </Grid>
        )}
        {/**Conditional rendering for TSJ INTERFACE */}
        {product.tsjInterface && (
          <Grid item xs={6}>
            <Stack
              alignItems="flex-start"
              justifyContent="flex-start"
              textAlign="left"
            >
              {typographyForCustomizedFontSize(
                "Tipo de salida del cable TSJ",
                "11px",
                null,
                "bold"
              )}
              {typographyForText(product.tsjInterface, "bold")}
            </Stack>
          </Grid>
        )}
        {/**Conditional rendering for POWER CORD CONNECTOR */}
        {product.powerCordConnector && (
          <Grid item xs={6}>
            <Stack
              alignItems="flex-start"
              justifyContent="flex-start"
              textAlign="left"
            >
              {typographyForCustomizedFontSize(
                "Tipo de conector de entrada",
                "11px",
                null,
                "bold"
              )}
              {typographyForText(product.powerCordConnector, "bold")}
            </Stack>
          </Grid>
        )}
        {/**Conditional rendering for DATACARD */}
        {product.datacard && (
          <Grid item xs={6}>
            <Stack
              alignItems="flex-start"
              justifyContent="flex-start"
              textAlign="left"
            >
              {typographyForCustomizedFontSize(
                "Datacard",
                "11px",
                null,
                "bold"
              )}
              {typographyForText(product.datacard, "bold")}
            </Stack>
          </Grid>
        )}
        {/**Conditional rendering for ETHERNET */}
        {product.ethernet && (
          <Grid item xs={6}>
            <Stack
              alignItems="flex-start"
              justifyContent="flex-start"
              textAlign="left"
            >
              {typographyForCustomizedFontSize(
                "Puerto RJ45",
                "11px",
                null,
                "bold"
              )}
              {typographyForText(product.ethernet, "bold")}
            </Stack>
          </Grid>
        )}
        {/**Conditional rendering for WALLKIT */}
        {product.wallkit && (
          <Grid item xs={6}>
            <Stack
              alignItems="flex-start"
              justifyContent="flex-start"
              textAlign="left"
            >
              {typographyForCustomizedFontSize(
                "Kit de Pared",
                "11px",
                null,
                "bold"
              )}
              {typographyForText(product.wallkit, "bold")}
            </Stack>
          </Grid>
        )}
        {/**Conditional rendering for company */}
        {product.company !== "" && (
          <Grid item xs={6}>
            <Stack
              alignItems="flex-start"
              justifyContent="flex-start"
              textAlign="left"
            >
              {typographyForCustomizedFontSize(
                "Agencia que solicita",
                "11px",
                null,
                "bold"
              )}
              {typographyForText(product.company, "bold")}
            </Stack>
          </Grid>
        )}
        {userData.role === "ADMINISTRATOR" && (
          <Grid item xs={12} sx={{ marginTop: "10px", marginBottom: "10px" }}>
            <Stack direction="row" spacing={1} justifyContent="center">
              <ContainedButton
                text={"editar orden"}
                endIcon={<Edit />}
                onClick={setEditOrderDrawer}
              />
              <ContainedButton
                text="Cancelar orden"
                color="error"
                startIcon={<Cancel color="error" />}
                onClick={setCancelOrderDrawer}
                variant="outlined"
                sx={{ color: "black" }}
              />
            </Stack>
          </Grid>
        )}
      </Grid>
    </Card>
  );
}
